import * as _ from 'lodash';

import axiosInstance from '../../../axiosInstance';
import { ValidateDiscountCodeType } from './types';

export const validateDiscountCode = async (
  payload: ValidateDiscountCodeType
) => {
  try {
    const data = _.get(payload, 'data');
    const res = await axiosInstance.post(
      'user/validateCoupon',
      { ...data },
      {
        headers: {
          Authorization: `Bearer ${payload.accessToken}`
        }
      }
    );
    return res.data;
  } catch (err) {
    throw new Error(
      err?.response?.data?.msg ||
        'An error occurred while applying discount code.'
    );
  }
};
